<template>
  <div>
    <p class="mb-4" qaid="customization-save-dialog-description">{{ $t('projectOne.config.save.enterName') }}</p>

    <pdl-form-group
      v-model="configurationName"
      type="text"
      :name="$t('projectOne.B2B.orderHistory.buildName').toLowerCase()"
      :maxlength="200"
      :label="$t('projectOne.B2B.orderHistory.buildName')"
      qaid="build-name-input"
      :error="getErrorMessage('configurationName')"
      required
    />

    <div class="buttons buttons--right">
      <pdl-button
        qaid="customization-save-dialog-save"
        primary
        :disabled="isProcessingCustomizationAction"
        @click="saveBuild"
      >
        <span>{{ $t('text.button.save') }}</span>
      </pdl-button>

      <pdl-button
        qaid="customization-save-dialog-cancel"
        secondary
        :disabled="isProcessingCustomizationAction"
        @click="closeDialog"
      >
        <span>{{ $t('text.button.cancel') }}</span>
      </pdl-button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {PdlButton} from '@pedal/pdl-button';
import {PdlToastType} from '@/constants/pdl-toast-type.js';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin.js';
import {Routes} from '@/constants/family-details.js';
import {SUMMARY_DIALOG_VIEWS} from '@/familyDetailsPage/store/bike-customization.js';

export default {
  name: 'CustomizationSaveBuildBody',
  components: {PdlFormGroup, PdlButton},
  mixins: [TrekValidationMixin],
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  data() {
    return {
      configurationName: '',
    };
  },
  validations() {
    return {
      configurationName: {
        required: this.trekValidators.required('projectOne.B2B.orderHistory.buildName'),
      },
    };
  },
  computed: {
    ...mapState('bikeCustomization', [
      'isSaveDialogVisible',
      'isCustomizationSummaryDialogOpen',
      'hasQueuedSubmitToRetailerAction',
      'queuedShareAction',
      'isProcessingCustomizationAction',
    ]),
  },
  mounted() {
    this.$emit('body-mounted');
  },
  methods: {
    ...mapMutations('bikeCustomization', [
      'setIsSaveDialogVisible',
      'setBikeDataConfigurationDescription',
      'setHasQueuedSaveAction',
      'setSummaryDialogView',
      'setIsProcessingCustomizationAction',
    ]),
    ...mapActions('bikeCustomization', ['saveConfig']),

    async saveBuild() {
      const isValid = await this.v$.$validate();
      if (!isValid) return;
      this.setBikeDataConfigurationDescription(this.configurationName);

      try {
        this.setIsProcessingCustomizationAction(true);
        const response = await this.saveConfig(true);

        await this.$router.replace({
          name: Routes.FDP_CUSTOMIZED_BUILD,
          params: {...this.$route.params, buildId: response?.data?.code},
        });
      } catch (error) {
        console.error(error);
        this.$notify({
          type: PdlToastType.WARNING,
          message: this.$t('errorMessage.unableToProcess'),
        });
      } finally {
        this.setIsProcessingCustomizationAction(false);
        if (this.isCustomizationSummaryDialogOpen) {
          if (this.hasQueuedSubmitToRetailerAction) {
            this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.SUBMIT_TO_RETAILER);
          } else if (this.queuedShareAction === 'EMAIL') {
            this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.SHARE_EMAIL);
          } else {
            this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.BUILD_SUMMARY);
          }
        } else {
          this.closeDialog();
        }
      }
    },

    closeDialog() {
      this.configurationName = '';
      this.v$.$reset();
      this.setIsSaveDialogVisible(false);
      this.setHasQueuedSaveAction(false);

      if (this.isCustomizationSummaryDialogOpen) {
        this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.BUILD_SUMMARY);
      }
    },
  },
};
</script>
